import React from 'react';


class Page extends React.Component {
  componentWillUpdate(nextProps) {
    if (nextProps.params !== this.props.params) {
      if (typeof window === 'object') {
        window.scrollTo(0, 0);
      }
    }
  }

  componentWillUnmount() {
    if (typeof window === 'object') {
      window.scrollTo(0, 0);
    }
  }
}

export default Page;



// WEBPACK FOOTER //
// ./app/pages/Page.jsx